angular.module 'zc.master'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.agencies',
    url: '/agencies'
    views:
      'content@':
        templateUrl: '/templates/master.agencies/list.html'
        controller: 'MasterAgenciesCtrl'
        resolve:
          agencies: (MasterAgency) ->
            MasterAgency.all()

  .state 'admin.master.agencies.new',
    url: '/new'
    views:
      'content@':
        templateUrl: '/templates/master.agencies/edit.html'
        controller: 'MasterAgenciesEditCtrl'
        resolve:
          shoppingCartAsps: (Meta) ->
            Meta.getShoppingCartAsps()
          invoiceCalculationTypes: (Meta) ->
            Meta.getInvoiceCalculationTypes()
          invoiceIssueDays: (Meta) ->
            Meta.getInvoiceIssueDays()
          invoicePaymentDays: (Meta) ->
            Meta.getInvoicePaymentDays()
          invoicePaymentMonths: (Meta) ->
            Meta.getInvoicePaymentMonths()
          salesEntities: (Meta) ->
            Meta.getSalesEntities()
          agency: ->
            { sales_entity: 'appier_jp', is_invoice_automated: true }
          users: ->
            []

  .state 'admin.master.agencies.edit',
    url: '/{id:int}/edit'
    views:
      'content@':
        templateUrl: '/templates/master.agencies/edit.html'
        controller: 'MasterAgenciesEditCtrl'
        resolve:
          shoppingCartAsps: (Meta) ->
            Meta.getShoppingCartAsps()
          invoiceCalculationTypes: (Meta) ->
            Meta.getInvoiceCalculationTypes()
          invoiceIssueDays: (Meta) ->
            Meta.getInvoiceIssueDays()
          invoicePaymentDays: (Meta) ->
            Meta.getInvoicePaymentDays()
          invoicePaymentMonths: (Meta) ->
            Meta.getInvoicePaymentMonths()
          salesEntities: (Meta) ->
            Meta.getSalesEntities()
          agency: (MasterAgency, $stateParams) ->
            MasterAgency.get(id: $stateParams.id)
          users: ($stateParams, MasterAgencyUser) ->
            MasterAgencyUser.all($stateParams.id)



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.agencies/routes.coffee